/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  if (window.location.href.indexOf('cart') > -1) {
    window.location.href = '/';
  }

  /* FREE TOY LOGIC — disabled, re-enable when needed

  // ?freetoy → variant 45047622926521
  var varID = 45047622926521;
  var urlParams = new URLSearchParams(window.location.search);
  var hasFreeToyCoupon = urlParams.has('freetoy');
  var giftLineItem = document.querySelectorAll('[data-item*="'+varID+'"]');

  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();
    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;
    formData.append('id', varID);
    formData.append('quantity', 1);
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: { freeGift: true, giftFormData: formData },
        bubbles: false,
      })
    );
  }

  // ?freetreats → variant 44462309245113
  var varID = 44462309245113;
  var urlParams = new URLSearchParams(window.location.search);
  var hasFreeToyCoupon = urlParams.has('freetreats');
  var giftLineItem = document.querySelectorAll('[data-item*="'+varID+'"]');

  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();
    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;
    formData.append('id', varID);
    formData.append('quantity', 1);
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: { freeGift: true, giftFormData: formData },
        bubbles: false,
      })
    );
  }

  // ?mysterygift → variant 45248685179065
  var varID = 45248685179065;
  var urlParams = new URLSearchParams(window.location.search);
  var hasFreeToyCoupon = urlParams.has('mysterygift');
  var giftLineItem = document.querySelectorAll('[data-item*="'+varID+'"]');

  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();
    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;
    formData.append('id', varID);
    formData.append('quantity', 1);
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: { freeGift: true, giftFormData: formData },
        bubbles: false,
      })
    );
  }

  */ // END FREE TOY LOGIC

  // Init Yotpo back in stock
  window.addEventListener('theme:variant:change', (e) => {
    if (window.smsBumpBackInStock) {
      window.smsBumpBackInStock.changeSelectedVariant(e.detail.variant.id);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
